/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

const Direction = {
	UP_DOWN: {
		previous: 'ArrowUp',
		next: 'ArrowDown'
	},
	LEFT_RIGHT: {
		previous: 'ArrowLeft',
		next: 'ArrowRight'
	}
};

export default Direction;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/a11y/src/js/Direction.js